<template>
  <div class="home-box fadeIn">
    <div class="banner icon-i">
      <div class="banner-text">
        <div class="banner-title">舟道学院：与公司共同成长</div>
        <div class="banner-en-title">——企业内训学习管理平台</div>
      </div>
    </div>
    <div class="title-box">
      <div class="main-title">探索我们的课程</div>
      <a-input-search class="input-search" v-model:value="keyword" placeholder="请输入课程名称搜索" @search="onSearch" />
    </div>
    <div class="catalog">
      <div class="catalog-item" :class="{ selected: active_cat == i }" v-for="(catalog, i) of catalog_list"
        @click="chooseCatalog(i)">{{ catalog.name }}</div>
    </div>
    <div class="catalog-title" v-if="catalog_list.length > 0">{{ catalog_list[active_cat].name }}</div>
    <a-spin :spinning="loading">
      <div class="course">
        <div class="course-box">
          <div class="course-item" v-for="course of show_list" @click="routerCourse(course)">
            <i class="course-cover icon-i" :style="{ backgroundImage: 'url(' + course.cover + ')' }"></i>
            <div class="course-info">
              <a-tooltip placement="topLeft">
                <template #title>{{ course.title }}</template>
                <div class="course-title ellipsis">{{ course.title }}</div>
              </a-tooltip>
              <div class="course-subTitle">{{ course.publisher }}</div>
            </div>
            <div class="course-bottom">
              <div class="unit">
                <svg class="icon-svg">
                  <use xlink:href="#icon-book" />
                </svg>
                <span>{{ course.codeCount || 0 }}个环节</span>
              </div>

              <div class="finish-status nojoin" v-if="course.userStatus == 'nojoin'">待学习</div>
              <div class="finish-status nofinish" v-if="course.userStatus == 'nofinish'">进行中</div>
              <div class="finish-status finished" v-if="course.userStatus == 'finish'">已完成</div>
            </div>
          </div>
          <empty_box warning="Sorry,暂无此类课程" v-if="digitalBookList.length == 0 && !loading"></empty_box>
        </div>
        <a-pagination class="page-box" v-model:current="page" :total="digitalBookList.length" :pageSize="pageSize"
          @change="changePage()" :hideOnSinglePage="true" show-less-items v-if="!loading" />
      </div>
    </a-spin>

    <foot v-if="!phoneMode"></foot>
  </div>
</template>

<script>
// @ is an alias to /src
import foot from "@/component/public/foot/foot.vue";
import router from '@/router';
import navroot from "@/component/public/nav/nav.vue";
import empty_box from "@/component/public/empty_box/empty_box.vue";


import { ONLINEURL } from '@/config/url';

export default {
  name: 'home',
  components: {
    navroot,
    foot,
    empty_box
  },
  data() {
    return {
      catalog_list: [],

      allDigitalBookList: [],
      digitalBookList: [],
      show_list: [],

      active_cat: 0,
      page: 1,
      pageSize: 9,

      keyword: '',
      userGuid: '',

      user: null,
      loading: true,
      phoneMode: false,
      needScroll: false,
    }
  },
  mounted() {
    this.$store.commit('showReturn', false);
    //监听
    this.$store.subscribe((res) => {
      if (!res) return;

      let { type, payload } = res;
      if (type == "phoneMode") this.phoneMode = payload;
    })

    this.setPageTemplate();
  },
  methods: {
    //设置pageTemplate
    setPageTemplate() {
      const { userInfo, catalogList, digitalBookList, phoneMode } = this.$store.state;
      this.user = userInfo;
      this.userGuid = userInfo.PK_UserGuid;
      this.allDigitalBookList = digitalBookList;
      this.catalog_list = catalogList;
      this.phoneMode = phoneMode;

      let rd_list = digitalBookList;
      this.last_rd = rd_list[rd_list.length - 1];
      this.rd_list = rd_list;

      let active_cat = 0;
      let { type } = this.$route.params; // 获取当前路由参数
      catalogList.forEach((item, i) => { if (type && type == item.type) active_cat = i });
      this.active_cat = active_cat;

      this.getStuRecord()
    },
    //查询学生所有记录
    async getStuRecord() {
      let res = await this.$api.unifydata.getStudentRecord(this.userGuid);
      if (res.statusCode != 200) return this.$message.error(res.message);
      let commitList = res.data;

      for (let item of this.allDigitalBookList) {
        let commit = commitList.find(citem => item.fk_class_id == citem.classId)
        if (commit) {
          let finishCode = commit.contents.length || 0;
          item.userStatus = finishCode >= item.codeCount ? 'finish' : 'nofinish';
        }
      }

      this.chooseCatalog(this.active_cat);
    },
    //关键词搜索
    onSearch() {
      this.chooseCatalog(0)
    },
    ////////////////////////////////分类
    //选择分类
    chooseCatalog(i) {
      this.active_cat = i

      let catalog = this.catalog_list[i];
      let allDigitalBookList = this.allDigitalBookList;

      let digitalBookList = [];
      if (catalog.name == '所有课程') digitalBookList = allDigitalBookList;
      else digitalBookList = allDigitalBookList.filter(item => item.type_list.indexOf(catalog.id) > -1);

      this.digitalBookList = digitalBookList.filter(item => item.title.indexOf(this.keyword) > -1);

      this.loading = false;

      this.page = 1;
      this.changePage();
    },
    //翻页
    changePage() {
      let page = this.page;
      let pageSize = this.pageSize;
      let digitalBookList = JSON.parse(JSON.stringify(this.digitalBookList));
      this.show_list = digitalBookList.slice((page - 1) * pageSize, page * pageSize);

      if (this.needScroll) $('#content').animate({ scrollTop: 500 }, 300);
      this.needScroll = true;
    },

    //滚动条移动
    catalog_scroll(type) {
      let scroll = $('.catalog').scrollLeft();
      if (type == 'left') $('.catalog').animate({ scrollLeft: scroll - 600 }, 300)
      else if (type == 'right') $('.catalog').animate({ scrollLeft: scroll + 600 }, 300)
    },

    //跳转
    routerCourse(item) {
      if (item.url) return window.open(item.url);

      if (item.userStatus == 'nofinish' || item.userStatus == 'finish') {
        let { platformUrl } = item;

        if (!platformUrl || platformUrl.indexOf('www.lessonplay.cn') > -1) window.open(`${ONLINEURL}/play/${item.pk_digital_book_id}`);
        else if (platformUrl.indexOf("lp.lessonplan") > -1) window.open(`${platformUrl}/list/${item.fk_class_id}?returnUrl=${location.href}`);
        else window.open(platformUrl)
        return;
      }

      $('#content').css('overflow-y', 'auto');
      $('#content').css('padding-right', '0px');

      router.push(`/course-info/${item.pk_digital_book_id}`);
    },
  }
}
</script>

<style lang="scss" scoped>
@import "./home.scss";
</style>
